import Input from "@JohnLewisPartnership/jl-design-system/dist/elements/input/Input";
import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import styles from "./PostcodeForm.module.scss";
import { TickCircleFilled } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/TickCircleFilled";
import { ChangeEvent } from "react";
import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";

type Props = {
  onChange: (value: string) => void;
  value: string;
  onSubmit: () => void;
  invalidPostcodeMessage?: string | null;
  availableSlotsErrorMessage?: string;
  isRequestInProgress?: boolean;
  isValidCode?: boolean;
  buttonEnabled: boolean;
};

const PostcodeForm = ({
  onChange,
  value,
  onSubmit,
  invalidPostcodeMessage,
  availableSlotsErrorMessage,
  isRequestInProgress,
  isValidCode,
  buttonEnabled,
}: Props) => {
  const errorMessage = invalidPostcodeMessage ?? availableSlotsErrorMessage;
  return (
    <div className={styles.PostcodeForm}>
      <div
        className={styles.PostcodeForm__title}
        data-testid="delivery-checker-section"
      >
        <label htmlFor="postcode">Find your earliest delivery dates</label>
      </div>
      <form
        className={styles.PostcodeForm__form}
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
        id="deliveryCheckerForm"
      >
        <div className={styles.PostcodeForm__inputContainer}>
          <div className={styles.PostcodeForm__input}>
            <Input
              id="postcode"
              name="postcode"
              aria-label="delivery-checker-postcode-input"
              data-testid="delivery-checker-postcode-input"
              value={value}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                if (isRequestInProgress) return;
                onChange(e.target.value);
              }}
              autoComplete="postal-code"
              placeholder="Enter your postcode"
            />
            {isValidCode && !errorMessage && (
              <TickCircleFilled
                size="large"
                className={styles.PostcodeForm__validIcon}
              />
            )}
          </div>

          <SecondaryButton
            data-testid="check-delivery-slots-button"
            submitting={isRequestInProgress}
            disabled={!buttonEnabled}
            className={styles.PostcodeForm__submitButton}
            type="submit"
            inline
          >
            Check
          </SecondaryButton>
        </div>
        {isRequestInProgress && (
          <p className={styles.PostcodeForm__busy}>
            We&apos;re checking your delivery options.
          </p>
        )}

        {!!errorMessage && (
          <div id="delivery-slots-error" role="alert" aria-live="polite">
            <Message
              body={errorMessage}
              type={"error"}
              className={styles.PostcodeForm__error}
            />
          </div>
        )}
      </form>
    </div>
  );
};

export default PostcodeForm;
